import { MapPin, Navigation, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface LocationPermissionExplainerProps {
  open: boolean;
  onClose: () => void;
  onAllow: () => void;
}

const features = [
  {
    icon: Navigation,
    title: "See Event Distances",
    description: 'Find events nearby with distances like "2.3 miles away"',
  },
  {
    icon: MapPin,
    title: "Check In at Events",
    description: "Verify your arrival and earn attendance rewards",
  },
  {
    icon: Shield,
    title: "Your Privacy Matters",
    description: "Location is only used when the app is open",
  },
];

export function LocationPermissionExplainer({
  open,
  onClose,
  onAllow,
}: LocationPermissionExplainerProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center pb-2">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <MapPin className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl">Enable Location Services?</DialogTitle>
          <DialogDescription className="text-base">
            Get the most out of Wellness Cowgirls
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary">
                <feature.icon className="h-5 w-5 text-primary" />
              </div>
              <div className="space-y-0.5">
                <p className="font-medium leading-tight">{feature.title}</p>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={onAllow} className="w-full">
            Continue
          </Button>
        </div>

        <p className="text-center text-xs text-muted-foreground pt-2">
          You can change this anytime in Settings
        </p>
      </DialogContent>
    </Dialog>
  );
}
